import { useEffect, useRef } from 'react'
import { useToast } from './Toast'

/** Toasts when the browser goes offline / back online (deduped while offline). */
export default function NetworkStatus() {
  const { show } = useToast()
  const offlineWarned = useRef(false)

  useEffect(() => {
    const onOffline = () => {
      if (offlineWarned.current) return
      offlineWarned.current = true
      show('You appear to be offline. Data may be stale until the connection returns.', 'warning')
    }
    const onOnline = () => {
      offlineWarned.current = false
      show('Connection restored.', 'success')
    }
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      onOffline()
    }
    window.addEventListener('offline', onOffline)
    window.addEventListener('online', onOnline)
    return () => {
      window.removeEventListener('offline', onOffline)
      window.removeEventListener('online', onOnline)
    }
  }, [show])

  return null
}
